import { DwQuery, InviteUser } from "./Query";

class DwQueryClient {
    private _baseUrl: string;

    constructor(baseUrl: string) {
        this._baseUrl = baseUrl;
    }

    public async doQuery(query: DwQuery, caller:String) {
        
        var url = `${this._baseUrl}/api/dw`;
        if (caller === "map"){
            url = `${this._baseUrl}/api/geojson`;
        }
        var headers = new Headers();
        headers.append("Content-Type", "application/json");

        const token = localStorage.getItem('syncarto_jwt');
        headers.append("Authorization", token ? `Bearer ${token}` : "");

        var raw = JSON.stringify(query);

        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: raw    
        });
        
        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            throw new Error(message);
        }

        // check if the response is null. the api returns null even though
        // the response is ok. if we do not have data, the json() call throws an
        // exception.
        //
        const text = await response.text();
        const data = text ? JSON.parse(text) : [];

        return data;
    }

    public async doQueryWithCancel(query: DwQuery, caller: string, options?: { signal?: AbortSignal }) {
        let url = `${this._baseUrl}/api/dw`;
        if (caller === "map") {
            url = `${this._baseUrl}/api/geojson`;
        }
    
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
    
        const token = localStorage.getItem('syncarto_jwt');
        headers.append("Authorization", token ? `Bearer ${token}` : "");
    
        const raw = JSON.stringify(query);
    
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers,
            body: raw
        };
    
        if (options?.signal) {
            requestOptions.signal = options.signal;
        }
    
        const response = await fetch(url, requestOptions);
    
        if (!response.ok) {
            const message = `An error has occurred: ${response.status}`;
            throw new Error(message);
        }
    
        // check if the response is null. the api returns null even though
        // the response is ok. if we do not have data, the json() call throws an
        // exception.
        const text = await response.text();
        const data = text ? JSON.parse(text) : [];
    
        return data;
    }
    

    public async doInviteUserQuery(query: InviteUser) {
        
        var url = `${this._baseUrl}/api/inviteuser`;
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        //headers.append("Sec-Fetch-Site", "cross-site");

        const token = localStorage.getItem('syncarto_jwt');
        headers.append("Authorization", token ? `Bearer ${token}` : "");

        var raw = JSON.stringify(query);
        
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: raw,
            //credentials: 'include',
            //referrerPolicy: 'unsafe-url',
            //site: 'cross-site',
            /*mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
                "sec-fetch-site": "cross-site"
            },*/
        });
        
        if (!response.ok) {
            const message = `An error has occured: ${response.status}`;
            throw new Error(message);
        }

        // check if the response is null. the api returns null even though
        // the response is ok. if we do not have data, the json() call throws an
        // exception.
        //
        const text = await response.text();
        const data = text ? JSON.parse(text) : [];

        return data;
    }
}

export default DwQueryClient;